// extracted by mini-css-extract-plugin
export var gif = "_ix-0";